let suppressedCameraHistoryMoves = 0;
let suppressedOrthoClippingSyncs = 0;

export function suppressNextCameraHistoryRecording() {
    suppressedCameraHistoryMoves += 1;
}

export function consumeSuppressedCameraHistoryRecording() {
    if (suppressedCameraHistoryMoves <= 0) {
        return false;
    }

    suppressedCameraHistoryMoves -= 1;
    return true;
}

export function suppressNextOrthoClippingSync() {
    suppressedOrthoClippingSyncs += 1;
}

export function consumeSuppressedOrthoClippingSync() {
    if (suppressedOrthoClippingSyncs <= 0) {
        return false;
    }

    suppressedOrthoClippingSyncs -= 1;
    return true;
}

// Used in tests.
export function resetSuppressedCameraHistoryRecording() {
    suppressedCameraHistoryMoves = 0;
    suppressedOrthoClippingSyncs = 0;
}
